export const OutputPage = () => {
    return <>OutputPage</>
}